export enum UserProfileNavItems {
    Overview = 'overview',
    Settings = 'settings',
    Security = 'security',
    Billing = 'billing',
    ActivityLogs = 'logs'
}

export enum PropertyProfileNavItems {
    Contacts = 'contacts',
    PropertyData = 'property-data',
    Invoicing = 'invoicing',
    PaymentHistory = 'payment-history',
    ActivityLogs = 'logs'
}

export enum MemberProfileNavItems {
    Properties = 'properties',
    Invoicing = 'invoicing',
    PaymentHistory = 'payment-history',
    CommunicationHistory = 'communication-history',
    ActivityLogs = 'logs',
    Settings = 'settings'
}

export enum OrganizationProfileNavItems {
    Overview = 'overview',
    Settings = 'settings',
    Contacts = 'contacts',
    Addresses = 'addresses',
    ActivityLogs = 'logs'
}
